import { Box, CircularProgress, Typography } from "@mui/material";

const SPINNER_SIZE = 28;
const SPINNER_THICKNESS = 4;

/**
 * Shown in place of the Deep View tab content while the lineage is being
 * fetched. Two stacked progress rings give the spinner a static track with a
 * rotating purple arc.
 */
const DeepViewTabsLoader = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 8,
    }}
  >
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        value={100}
        size={SPINNER_SIZE}
        thickness={SPINNER_THICKNESS}
        sx={{ color: "#EEEEEE" }}
      />
      <CircularProgress
        disableShrink
        size={SPINNER_SIZE}
        thickness={SPINNER_THICKNESS}
        sx={{
          color: "#9C27B0",
          position: "absolute",
          left: 0,
        }}
      />
    </Box>

    <Typography sx={{ fontSize: "13px", color: "#00000099", mt: 1.5 }}>
      Tracing data lineage…
    </Typography>
  </Box>
);

export default DeepViewTabsLoader;
